import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import { CardField } from 'payments/components/CardField';
import { PaymentFieldTypes } from 'payments/constants/card';
import { type CardFieldStates } from 'payments/types/card';

export const CARD_NUMBER = 'card-number';
export const CARD_DATE = 'card-date';
export const CARD_CVC = 'card-cvv';
export const CARD_POSTAL = 'card-postal-code';

interface CardElementProps {
  id: string;
}

const CardElement = ({ id }: CardElementProps) => (
  <Box
    sx={{
      boxSizing: `content-box`,
      display: 'flex',
      height: '23px',
      padding: '14px 0 14px 12px',
      width: '100%'
    }}
  >
    <div id={id} />
  </Box>
);

const CardErrorElement = (
  <Typography
    sx={theme => ({
      color: theme.palette.error.main,
      fontSize: '14px'
    })}
    data-testid="card-declined-error-msg"
  >
    Your card was declined. Please check that the information is correct or try
    another payment method.
  </Typography>
);

const CardNumberElement = () => <CardElement id={CARD_NUMBER} />;
const CardExpiryElement = () => <CardElement id={CARD_DATE} />;
const CardCvcElement = () => <CardElement id={CARD_CVC} />;
const CardPostalElement = () => <CardElement id={CARD_POSTAL} />;

interface CardFieldsContainerProps {
  cardFieldStates?: CardFieldStates;
  cardDeclinedError?: boolean;
}

export const CardFieldsContainer = ({
  cardFieldStates,
  cardDeclinedError = false
}: CardFieldsContainerProps) => (
  <Grid container gap="16px" mb="32px" data-testid="card-fields-container">
    <Grid item xs>
      <CardField
        label="Card Number"
        name={PaymentFieldTypes.CARD_NUMBER}
        InputEl={CardNumberElement}
        fieldState={cardFieldStates?.CARD_NUMBER}
        cardDeclinedError={cardDeclinedError}
      />
    </Grid>
    <Grid item container direction="row" spacing={2}>
      <Grid item xs>
        <CardField
          label="MM/YY"
          name={PaymentFieldTypes.EXPIRATION_DATE}
          InputEl={CardExpiryElement}
          fieldState={cardFieldStates?.CARD_DATE}
          cardDeclinedError={cardDeclinedError}
        />
      </Grid>
      <Grid item xs>
        <CardField
          label="CVV"
          name={PaymentFieldTypes.CVC}
          InputEl={CardCvcElement}
          fieldState={cardFieldStates?.CARD_CVV}
          cardDeclinedError={cardDeclinedError}
        />
      </Grid>
      <Grid item xs>
        <CardField
          label="Zip"
          name={PaymentFieldTypes.ZIP_CODE}
          InputEl={CardPostalElement}
          fieldState={cardFieldStates?.CARD_POSTAL_CODE}
          cardDeclinedError={cardDeclinedError}
        />
      </Grid>
    </Grid>
    {cardDeclinedError ? CardErrorElement : null}
  </Grid>
);
